import { Skeleton } from '@mui/material'
import { Link as UnstyledLink } from 'react-router-dom'
import styled from 'styled-components'
import { useQueryClient } from 'react-query'

import { logout, RequireAuth } from '../core/AccountProvider'
import navigate from '../core/navigate'
import { useAccountQuery } from '../core/queries'
import BiddingStatusDialog from './BiddingStatusDialog'

const LinkList = styled.ul`
  margin-top: 0;
  padding: 0;
  display: inline-block;
  margin-bottom: 6px;
`

const LinkItem = styled.li`
  padding: 0 5px;
  display: inline-block;

  :not(:first-child) {
    margin: 0;
    border-left: 1px solid #ede9f2;
  }

  :last-child {
    padding-right: 0;
  }
`

const Link = styled(UnstyledLink)`
  color: black;
  background: none;
  border: none;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;
  text-decoration-color: #ccc;
`

const AccountItem = styled(LinkItem)`
  :hover span {
    background-color: #361611;
    color: white;
  }
`

const AccountId = styled.span`
  margin-left: 4px;
  padding: 3px 4px;
  display: inline-block;
  line-height: 1em;
  border-radius: 4px;
  font-size: 12px;
  color: #606060;
  background-color: #f2f0ed;
  transition: all 0.3s;
`

const handleLogout = (client) => {
  const pathname = window.location.pathname
  logout(client)
  if (pathname.includes('/account/', 0)) navigate('/account/login')
}

const LoginLink = () => {
  const { pathname, search } = window.location

  return (
    <LinkItem>
      <Link
        as='button'
        id='header_login'
        onClick={() => {
          // If not on /account/login or /account/register page...
          if (!pathname.match(/^\/account\/(login|register)/))
            navigate(`/account/login?return=${pathname}${search}`)
        }}>
        Login or Register
      </Link>
    </LinkItem>
  )
}

export default () => {
  const { data: accountData, isLoading: isAccountLoading } = useAccountQuery()
  const client = useQueryClient()
  return (
    <LinkList>
      <RequireAuth unauthorized={<LoginLink />}>
        <LinkItem>
          <BiddingStatusDialog />
        </LinkItem>
        <AccountItem>
          <Link as='a' id='header_account' href='/account/bids'>
            My Account
            <AccountId>{isAccountLoading ? <Skeleton width={42} /> : accountData.id}</AccountId>
          </Link>
        </AccountItem>
        <LinkItem>
          <Link as='button' id='header_logout' onClick={() => handleLogout(client)}>
            Logout
          </Link>
        </LinkItem>
      </RequireAuth>

      <LinkItem>
        <Link as='a' id='header_contact' href='/contact/us'>
          Contact Us
        </Link>
      </LinkItem>
    </LinkList>
  )
}
